<template>
  <div>转化率：{{ tableHead && tableHead.change_rate }}</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'headerComponentMjstoreCustomerListWithCustomerType',
  props: {
    tableHead: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
});
</script>
<style></style>
